import { LayoutProps } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsLayoutProps } from "@jsonforms/react";

function GroupLayoutComponent({
  uischema,
  schema,
  path,
  visible,
  renderers,
  cells,
  enabled,
}: LayoutProps) {
  if (!visible) return null;

  const layout = uischema as { elements: any[]; label?: string };

  return (
    <div className="space-y-4 border-t py-4 dark:border-gray-700">
      {layout.label && (
        <span className="text-sm font-medium">{layout.label}</span>
      )}
      {layout.elements.map((element, index) => (
        <JsonFormsDispatch
          key={index}
          uischema={element}
          schema={schema}
          path={path}
          renderers={renderers}
          cells={cells}
          enabled={enabled}
        />
      ))}
    </div>
  );
}

export const GroupLayout = withJsonFormsLayoutProps(GroupLayoutComponent);
